export const routes =  (prefix = `morgue`) => [
    {
        path: `/${prefix}/current-discharge`,
        name: `${prefix}.current-discharge.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.current-discharge.index`,
                PageDescription: "Morgue: current discharge list",
            },
        },
    },
    {
        path: `/${prefix}/current-discharge-print`,
        name: `${prefix}.current-discharge-print.index`,
        component: () => import('./prints/CurrentDischarge.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.current-discharge.index`,
                PageDescription: "Morgue: current discharge list",
            },
        },
    },
];
